import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
  Paper,
  Card,
  CardContent,
  Grid,
  Dialog,
  DialogTitle,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Snackbar, Alert } from "@mui/material";
import { tokens } from "../components/Theme";
import { useSwipeable } from "react-swipeable";
import { GlobalStyles } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Fab } from "@mui/material";
import MapSinglePin from "./GoogleMapPin";
import MapMarkerViewer from "./GoogleMapPinView";
import CreateFarm from "../api/farm/CreateFarm";
import GetFarm from "../api/farm/GetFarm";
import DeleteFarm from "../api/farm/DeleteFarm";
import DeleteIcon from "@mui/icons-material/Delete";
import { locations } from "../api/data/locationData";
function FarmManage() {
  const theme = useTheme();
  const userData = JSON.parse(localStorage.getItem("userdata"));
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [create, setCreate] = useState(false);
  const [payload, setPayload] = useState([]);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [targetFarmId, setTargetFarmId] = useState(null);
  const [open, setOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [formData, setFormData] = useState({
    appFarmerId: userData.appFarmerId,
    appFarmId: "",
    tambon: "",
    amphur: "",
    province: "",
    lat: "",
    lon: "",
  });
  const [provinceList, setProvinceList] = useState(Object.keys(locations));
  const [amphurList, setAmphurList] = useState([]);
  const [tambonList, setTambonList] = useState([]);
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };
  const handleDeleteRow = async (appFarmId) => {
    try {
      await DeleteFarm({ appFarmId: appFarmId });
      const updated = await GetFarm({ appFarmerId: userData.appFarmerId });
      setPayload(updated);
      setSnackbarSeverity("success");
      setSnackbarMessage("ลบฟาร์มสำเร็จ");
      setOpenSnackbar(true);
    } catch (error) {
      console.error("Error deleting farm:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage("เกิดข้อผิดพลาดในการลบ");
      setOpenSnackbar(true);
    }
  };
  const handleProvinceChange = (e) => {
    const province = e.target.value;
    setFormData((prev) => ({
      ...prev,
      province,
      amphur: "",
      tambon: "",
    }));
    setAmphurList(Object.keys(locations[province] || {}));
    setTambonList([]);
  };

  const handleAmphurChange = (e) => {
    const amphur = e.target.value;
    setFormData((prev) => ({
      ...prev,
      amphur,
      tambon: "",
    }));
    setTambonList(Object.keys((locations[formData.province] || {})[amphur] || {}));
  };

  const handleTambonChange = (e) => {
    const tambon = e.target.value;
    setFormData((prev) => ({
      ...prev,
      tambon,
    }));
  };

  const columns = [
    { field: "tambon", headerName: "ตำบล", flex: 1 },
    { field: "amphur", headerName: "อำเภอ", flex: 1 },
    { field: "province", headerName: "จังหวัด", flex: 1 },
    { field: "lat", headerName: "ละติจูด", flex: 1 },
    { field: "lon", headerName: "ลองติจูด", flex: 1 },
    {
      field: "actions",
      headerName: "ลบ",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <DeleteIcon
          style={{ cursor: "pointer", color: "red" }}
          onClick={() => {
            setTargetFarmId(params.row.appFarmId);
            setConfirmDeleteOpen(true);
          }}
        />
      ),
    }
  ];
  const handleSubmitCreateFarm = async () => {
    try {
      const result = await CreateFarm(formData);
      if (result.status === 200) {
        setFormData({
          appFarmerId: userData.appFarmerId,
          appFarmId: "",
          tambon: "",
          amphur: "",
          province: "",
          lat: "",
          lon: "",
        })
        const response = await GetFarm({ appFarmerId: userData.appFarmerId });
        setPayload(response);
        setSnackbarSeverity("success");
        setSnackbarMessage("สร้างฟาร์มสำเร็จ");
        setOpenSnackbar(true);

        setTimeout(() => {
          setCreate(false);
          handleDialogClose();
        }, 1000);
      } else {
        setSnackbarSeverity("error");
        setSnackbarMessage("เกิดข้อผิดพลาด");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error creating farm:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage("เกิดข้อผิดพลาด");
      setOpenSnackbar(true);
    }
  };
  useEffect(() => {
    const fetchFarmerData = async () => {
      if (userData.registor === 1) {
        try {
          const response = await GetFarm({ appFarmerId: userData.appFarmerId });
          setPayload(response);
        } catch (error) {
          console.error("Error fetching farmer data:", error);
        }
      }
    };

    fetchFarmerData();
  }, []);
  useEffect(() => {
    if (openSnackbar) {
      const timer = setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [openSnackbar]);

  const handleDialogOpen = () => {
    setOpen(true);
  };

  const handleDialogClose = (value) => {
    setOpen(false);
  };

  const payloadToRow = (payload) => {
    return payload.map((item, index) => ({
      id: index + 1,
      ...item,
    }));
  };

  const rows = payloadToRow(payload);

  useEffect(() => {
  }, [formData]);

  const handlePinFinish = (data) => {
    setFormData((prev) => ({
      ...prev,
      lat: data.point.lat,
      lon: data.point.lng,
    }));

    if (data.confirm) {
      handleDialogOpen();
      // setCreate(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSwipe = useSwipeable({
    onSwipedLeft: () => {
      if (rows.length > 0) {
        setCurrentIndex((prev) => (prev + 1) % rows.length);
      }
    },
    onSwipedRight: () => {
      if (rows.length > 0) {
        setCurrentIndex((prev) => (prev - 1 + rows.length) % rows.length);
      }
    },
    trackMouse: true,
  });

  return (
    <>
      <GlobalStyles
        styles={{
          html: { margin: 0, padding: 0, overflow: "hidden", height: "100%" },
          body: { margin: 0, padding: 0, overflow: "hidden", height: "100%" },
        }}
      />
      {create ? (
        <Box
          height={isMobile ? "86vh" : "91vh"}
          overflow={isMobile ? "hidden" : "none"}
        >
          <Box
            sx={{
              width: "100%",
              p: 2,
              backgroundColor: colors.greenAccent[400],
            }}
          >
            <Grid container spacing={2}>
              <Grid item size={{ xs: 4, md: 4, lg: 4, xl: 4 }}>
                <FormControl fullWidth>
                  <InputLabel id="province-label">จังหวัด</InputLabel>
                  <Select
                    labelId="province-label"
                    name="province"
                    value={formData.province}
                    onChange={handleProvinceChange}
                    sx={{ backgroundColor: "#fff" }}
                  >
                    {provinceList.map((province) => (
                      <MenuItem key={province} value={province}>
                        {province}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item size={{ xs: 4, md: 4, lg: 4, xl: 4 }}>
                <FormControl fullWidth>
                  <InputLabel id="amphur-label">อำเภอ</InputLabel>
                  <Select
                    labelId="amphur-label"
                    name="amphur"
                    value={formData.amphur}
                    onChange={handleAmphurChange}
                    disabled={!formData.province}
                    sx={{ backgroundColor: "#fff" }}
                  >
                    {amphurList.map((amphur) => (
                      <MenuItem key={amphur} value={amphur}>
                        {amphur}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item size={{ xs: 4, md: 4, lg: 4, xl: 4 }}>
                <FormControl fullWidth>
                  <InputLabel id="tambon-label">ตำบล</InputLabel>
                  <Select
                    labelId="tambon-label"
                    name="tambon"
                    value={formData.tambon}
                    onChange={handleTambonChange}
                    disabled={!formData.amphur}
                    sx={{ backgroundColor: "#fff" }}
                  >
                    {tambonList.map((tambon) => (
                      <MenuItem key={tambon} value={tambon}>
                        {tambon}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
          </Box>
          <Box height={isMobile ? "75%" : "85%"}>
            <MapSinglePin data={handlePinFinish} />
          </Box>
        </Box>
      ) : (
        <Box>
          <Box
            height={isMobile ? "86vh" : "91vh"}
            overflow={isMobile ? "hidden" : "none"}
          >
            <Box height="45%" borderRadius="10px" m="10px">
              <MapMarkerViewer payload={payload} />
            </Box>

            <Box height="50%" p={1}>
              <Paper elevation={3} sx={{ height: "100%", p: 2 }}>
                <Typography variant="h6" gutterBottom>
                  รายการที่ตั้งฟาร์ม
                </Typography>

                {!isMobile ? (
                  <Box sx={{ height: "calc(100% - 40px)" }}>
                    <DataGrid
                      rows={rows}
                      columns={columns}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      disableRowSelectionOnClick
                      sx={{
                        border: "none",
                        "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: colors.greenAccent[400],
                          color: "#000",
                          fontWeight: "bold",
                        },
                        "& .MuiDataGrid-row:hover": {
                          backgroundColor: colors.greenAccent[400],
                        },
                      }}
                    />
                  </Box>
                ) : (
                  <Box
                    {...handleSwipe}
                    sx={{
                      mt: "-50px",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {rows.length > 0 ? (
                      <Card sx={{ width: "100%", maxWidth: 300 }}>
                        <CardContent>
                          <Typography variant="subtitle1" fontWeight="bold">
                            จังหวัด: {rows[currentIndex].province}
                          </Typography>
                          <Typography>ตำบล: {rows[currentIndex].tambon}</Typography>
                          <Typography>อำเภอ: {rows[currentIndex].amphur}</Typography>
                          <Typography>ละติจูด: {rows[currentIndex].lat}</Typography>
                          <Typography>ลองติจูด: {rows[currentIndex].lon}</Typography>
                          <Box mt={2} display="flex" justifyContent="center">
                            <IconButton
                              onClick={() => {
                                setTargetFarmId(rows[currentIndex].appFarmId);
                                setConfirmDeleteOpen(true);
                              }}
                              sx={{
                                color: "red",
                                border: "1px solid red",
                                borderRadius: 2,
                                px: 2,
                                py: 0.5,
                              }}
                            >
                              <DeleteIcon />
                              <Typography sx={{ ml: 1 }}>ลบ</Typography>
                            </IconButton>
                          </Box>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            display="block"
                            mt={2}
                            align="center"
                          >
                            {currentIndex + 1} / {rows.length}
                          </Typography>
                        </CardContent>
                      </Card>
                    ) : (
                      <Typography variant="body1">ไม่มีข้อมูลฟาร์ม</Typography>
                    )}
                  </Box>
                )}

              </Paper>
            </Box>
          </Box>
          <Fab
            color="primary"
            aria-label="add"
            sx={{
              position: "fixed",
              bottom: 16,
              right: 16,
              zIndex: 1000,
              backgroundColor: colors.greenAccent[500],
              "&:hover": {
                backgroundColor: colors.greenAccent[600],
              },
            }}
            onClick={() => {
              setCreate(true);
            }}
          >
            <AddIcon />
          </Fab>
        </Box>
      )}
      <Dialog onClose={handleDialogClose} open={open}>
        <DialogTitle>ยืนยันการสร้างฟาร์ม</DialogTitle>
        <Box p={3}>
          <Box display="flex" justifyContent="space-around">
            <Typography>ตำบล : </Typography>
            <Typography>{formData.tambon}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-around">
            <Typography>อำเภอ : </Typography>
            <Typography>{formData.amphur}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-around">
            <Typography>จังหวัด : </Typography>
            <Typography>{formData.province}</Typography>
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-around">
          <Button
            onClick={() => {
              handleDialogClose();
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={async () => {
              await handleSubmitCreateFarm();
            }}
          >
            บันทึก
          </Button>

        </Box>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={1000} // ปิดเองหลัง 1 วิ
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "center", horizontal: "center" }}
        sx={{
          // เพิ่มความกว้างสูงให้ Snackbar กลางจอจริง ๆ
          "& .MuiSnackbarContent-root": {
            justifyContent: "center",
            minWidth: "200px",
            textAlign: "center",
          },
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Dialog open={confirmDeleteOpen} onClose={() => setConfirmDeleteOpen(false)}>
        <DialogTitle>ยืนยันการลบฟาร์ม</DialogTitle>
        <Box p={2}>
          <Typography>คุณแน่ใจหรือไม่ว่าต้องการลบฟาร์มนี้?</Typography>
        </Box>
        <Box display="flex" justifyContent="space-around" pb={2}>
          <Button
            variant="outlined"
            onClick={() => {
              setConfirmDeleteOpen(false);
              setTargetFarmId(null);
            }}
          >
            ยกเลิก
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={async () => {
              if (targetFarmId) {
                await handleDeleteRow(targetFarmId);
              }
              setConfirmDeleteOpen(false);
              setTargetFarmId(null);
            }}
          >
            ลบ
          </Button>
        </Box>
      </Dialog>

    </>
  );
}

export default FarmManage;
